import request from '../utils/request';

/**
 * 获取用户技能分页列表
 * @param {Object} params - 查询参数
 * @returns {Promise} - 返回请求结果
 */
export function getUserSkillList(params) {
  return request({
    url: '/user-skills/list',
    method: 'get',
    params
  });
} 